import { render } from "./rank-category.vue?vue&type=template&id=b6594e1e&scoped=true"
import script from "./rank-category.vue?vue&type=script&lang=js"
export * from "./rank-category.vue?vue&type=script&lang=js"

import "./rank-category.vue?vue&type=style&index=0&id=b6594e1e&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6594e1e"]])

export default __exports__